document.addEventListener('DOMContentLoaded', function () {
  const accept = document.querySelector('.modalAccept');
  const decline = document.querySelector('.modalDecline');
  const close = document.querySelector('.modalClose');
  const container = document.querySelector('.modalWrap');

  let value = localStorage.getItem('modal');

  if (value === 'false' || value === null) {
    container.style.display = 'flex';
  }

  if (accept) {
    accept.addEventListener('click', () => {
      localStorage.setItem('modal', true);
      container.style.display = 'none';
    });
  }

  if (decline) {
    decline.addEventListener('click', () => {
      localStorage.setItem('modal', true);
      container.style.display = 'none';
    });
  }

  if (close) {
    close.addEventListener('click', () => {
      container.style.display = 'none';
    });
  }
});
